
export default function Services() {
  const services = [
    {
      icon: 'ri-water-flash-line',
      title: 'Perforación de Pozos',
      description: 'Perforaciones profundas con tecnología de punta para garantizar agua de calidad.',
      image: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/e87124bcba69893f0cafd1314d958337.png'
    },
    {
      icon: 'ri-earth-line',
      title: 'Estudios geofísicos',
      description: 'Análisis técnico del subsuelo para identificar las mejores zonas acuíferas.',
      image: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/b77e6be7ebe8a12109bfccb14f14367f.jpeg'
    },
    {
      icon: 'ri-brush-line',
      title: 'Limpieza de pozos',
      description: 'Servicios de limpieza, desinfección y mantenimiento preventivo.',
      image: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/2f0253b12bf166076092851d3c086a46.png'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Instalación de bombas',
      description: 'Instalación profesional de sistemas de bombeo sumergibles y superficiales.',
      image: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/cc1de565d5b919daf2783b4fd8b7c5e7.png'
    },
    {
      icon: 'ri-water-percent-line',
      title: 'Sistemas de agua',
      description: 'Diseño e implementación de sistemas completos de distribución de agua.',
      image: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/ecde84ffe03b99e6fdf2eb82d1f7a60c.png'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Asesoría técnica',
      description: 'Consultoría especializada en proyectos hídricos y evaluación de viabilidad.',
      image: 'https://public.readdy.ai/ai/img_res/ee065ccafb742646ac90c2d618a46716.jpg'
    }
  ];

  return (
    <section className="py-10 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-2 sm:mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Soluciones integrales en perforación acuífera y sistemas de agua
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              <div className="relative h-40 sm:h-48 lg:h-56 w-full overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 left-3 w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 rounded-lg flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-lg sm:text-xl text-white`}></i>
                </div>
              </div>
              <div className="p-4 sm:p-5 lg:p-6">
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1.5 sm:mb-2">
                  {service.title}
                </h3>
                <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
